import * as joint from "jointjs";

const SVG_NS = "http://www.w3.org/2000/svg";

export const withSvgTooltip = <T extends joint.dia.ToolView>(tool: T, tooltip: string): T => {
  const originalOnRender = typeof tool.onRender === "function" ? tool.onRender : undefined;
  tool.onRender = function (...args: unknown[]) {
    originalOnRender?.apply(this, args as []);
    const existing = this.el.querySelector("title");
    if (existing) {
      existing.textContent = tooltip;
      return;
    }
    const title = document.createElementNS(SVG_NS, "title");
    title.textContent = tooltip;
    this.el.prepend(title);
  };
  return tool;
};
